import Vue from 'vue'
import VDrag from 'v-drag'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/styles/index.scss' // global css
import './permission' // permission control
import { NumberKeyboard} from 'vant';
import 'vant/lib/index.css';
import '@vant/touch-emulator';

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VDrag);
Vue.use(NumberKeyboard);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
